import React, { useState, useEffect } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import "../CSS/status.css";
import { getRequest, deactivateRequestWithVerify } from "../../api/requests";
import ReactReqLogo from "../assets/req-status-nothing.svg";
import { decrementActiveRequestCount } from "../../api/stats";

// 8576139

export default function RequestStatusPage(props: any) {
  //keeps the id of the request
  const [id, setId] = useState("");

  //records if search has been used once
  const [used, setUsed] = useState(false);

  //keeps record if the given request is asked to be deactivated
  const [deactivated, setDeactivated] = useState(false);

  //it contains the message that shows up in case request is failed to be deactivated
  const [deactiveMsg, setDeactiveMSG] = useState("");

  //keeps the record of the request status
  const [status, setStatus] = useState(Object());

  //Loading Screen
  const [loading, setLoading] = useState(false);

  //Handles request submit
  const handleRequestSubmit = (values: any, { setSubmitting }: any) => {
    console.log(values);
    setDeactivated(false);
    const temp = { ...values };
    setDeactiveMSG("");
    setLoading(true);
    setUsed(true);
    if (!props.location.search) {
      props.history.push({
        search: "?id=" + temp.requestId,
      });
    }
    setId(temp.requestId);
    getRequest(temp.requestId)
      .then((res: object) => {
        if (res) {
          setStatus({ ...res, requestId: temp.requestId });
        }
        setSubmitting(false);
        setLoading(false);
      })
      .catch((rej) => {
        if (!rej) {
          setId("");
        }
        setSubmitting(false);
        setLoading(false);
      });

    values.requestId = "";
  };

  //UseEffect to trigger auto submit
  useEffect(() => {
    if (props.location.search && props.location.search.slice(0, 4) == "?id=") {
      console.log(props.location.search.slice(4));
      const values = { requestId: props.location.search.slice(4) };
      handleRequestSubmit(values, { setSubmitting: () => null });
    }
  }, []);

  //shows the card indicating no request
  const nothing = (
    <div id="no-request">
      <div id="first-element"> Request Status </div>
      <div id="second-element">
        No request found! :( <br /> The request might no longer be active.{" "}
        <br /> Requests expire after every 3 days.
      </div>
    </div>
  );

  const nothingFirst = (
    <div id="req-nothing-logo">
      <img src={ReactReqLogo} alt="nothing"></img>
    </div>
  );

  // bottom is used for showing the status of the request
  // top is used for showing the headings for the status
  const top = (
    <div>
      <div>
        <table className="table-req" id="request-table">
          <thead>
            <th>Request ID</th>
            <th>City</th>
            <th>Blood Groud</th>
            <th>Activation Date</th>
            <th>Type</th>
            <th>Status</th>
          </thead>
          <tbody>
            <tr>
              <td data-label="Request ID">{status.requestId}</td>
              <td data-label="City">{status.city}</td>
              <td data-label="Blood Group">{status.bloodGroup}</td>
              <td data-label="Activation Date">
                {status.date
                  ? new Date(status.date.seconds * 1000).toLocaleDateString()
                  : 0}
              </td>
              <td data-label="Type">{status.type}</td>
              <td data-label="Status">
                <button
                  className={`${
                    status.isActive ? "btn btn-success" : "btn btn-danger"
                  }`}
                >
                  {status.isActive ? "Active" : "Inactive"}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {status.isActive ? (
        <button
          className="btn btn-danger"
          id="deactive-btn"
          data-target="#delete-modal"
          data-toggle="modal"
        >
          Deactivate
        </button>
      ) : (
        ""
      )}
      <div id="delete-modal" className="modal fade">
        <div className="modal-dialog modal-confirm">
          <div className="modal-content">
            <div className="modal-header">
              <div className="icon-box">
                <i className="fas fa-exclamation-circle"></i>
              </div>
              <h4 className="modal-title">Deactivate Request</h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-hidden="true"
              >
                &times;
              </button>
            </div>
            <div className="modal-body">
              <p>Enter the Phone Number you used for making this request</p>
              <Formik
                initialValues={{ phoneNumber: "" }}
                validationSchema={Yup.object({
                  phoneNumber: Yup.string()
                    .matches(
                      /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[\s./0-9]*$/,
                      "Invalid phone number. Please enter number in format 03xxxxxxxxx"
                    )
                    .min(11)
                    .max(11)
                    .required("Required"),
                })}
                onSubmit={(values, { setSubmitting }) => {
                  const temp = { ...values };
                  setDeactiveMSG("");
                  deactivateRequestWithVerify(id, temp.phoneNumber).then(
                    (res) => {
                      if (res) {
                        setDeactivated(true);
                        setSubmitting(false);
                        setDeactiveMSG("Deactivated!");
                        decrementActiveRequestCount();
                        $('#delete-modal').modal('hide')
                      } else {
                        setSubmitting(false);
                        setDeactivated(false);
                        setDeactiveMSG("Failed to Deactivate! Try again");
                      }
                    }
                  );
                  values.phoneNumber = "";
                }}
              >
                {({ isSubmitting, errors }) => (
                  <Form>
                    <div id="status-feedback">{deactiveMsg}</div>
                    <div id="deactivate-field-title">Phone Number: </div>
                    <div>
                      <Field
                        id="deactivate-field"
                        className={`form-control ${
                          errors.phoneNumber ? "is-invalid" : ""
                        }`}
                        name="phoneNumber"
                        type="text"
                        placeholder="Phone Number"
                      />
                    </div>
                    <div id="status-feedback">
                      <ErrorMessage name="phoneNumber" />
                    </div>
                    <div>
                      <button
                        id="deactivate"
                        className="btn btn-danger"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <div
                            className="spinner-border text-light"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        ) : (
                          "Deactivate Request"
                        )}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="mainContainer">
      <Formik
        initialValues={{ requestId: "" }}
        validationSchema={Yup.object({
          requestId: Yup.string()
            .test("len", "Must be exactly 7 characters", (val) =>
              val ? val.length === 7 : false
            )
            .required("Required"),
        })}
        onSubmit={handleRequestSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            <div id="bg-img">
              <div className="form-request" id="request-form">
                <div></div>
                <h3 id="request-field-title">Search Request</h3>
                <div></div>
                <div></div>
                <div id="request-search">
                  <div id="cover">
                    <Field
                      id="request-field"
                      className="form-control"
                      name="requestId"
                      type="text"
                      placeholder="Enter the 7-digit Request ID"
                    />
                    <button id="search-button" type="submit">
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                </div>
                <div></div>
                <div></div>
                <div className="error-message">
                  <ErrorMessage name="requestId" />
                </div>
                <div></div>
              </div>
            </div>
          </Form>
        )}
      </Formik>

      {id !== "" ? (
        <div>
          {loading ? (
            <div id="spinner" className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            ""
          )}
          {top} {/* {bottom} */}
        </div>
      ) : used ? (
        nothing
      ) : (
        nothingFirst
      )}
      {deactivated ? (
        <div id="request-alert" className="alert alert-danger">
          Request Deactivated
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
}
